(function () {
  var SIZE_NAME = /talla|size|tama|medida|numero|número/i;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function formatMoney(cents) {
    var amount = Math.round(Number(cents) / 100);
    return '$' + amount.toLocaleString('en-US');
  }

  function fill(template, map) {
    return String(template || '').replace(/\[(\w+)\]/g, function (_, key) {
      return map[key] != null ? map[key] : '';
    });
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
    });
  }

  function normalize(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]/g, '');
  }

  // Shopify Bundles names each bundle option after its component, e.g. "Pantalón Cowboy Black (Size)".
  function pieceName(optionName) {
    return String(optionName || '')
      .replace(/\s*\([^)]*\)\s*$/, '')
      .replace(/\*+/g, '')
      .trim();
  }

  function isGift(item) {
    var props = (item && item.properties) || {};
    return props._is_gift_bag === 'true' || props._is_gift_bag === true;
  }

  function cartLines(cart) {
    return ((cart && cart.items) || []).filter(function (item) {
      return !isGift(item) && item.handle;
    });
  }

  function shopRoot() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function cartUrl() {
    return (window.routes && window.routes.cart_url) || shopRoot() + 'cart';
  }

  function fetchJson(url) {
    return fetch(url, { headers: { Accept: 'application/json' } }).then(function (response) {
      if (!response.ok) throw new Error('request');
      return response.json();
    });
  }

  function postJson(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (response) {
      if (!response.ok) throw new Error('request');
      return response.json();
    });
  }

  function fetchProduct(handle) {
    return fetchJson(shopRoot() + 'products/' + encodeURIComponent(handle) + '.js');
  }

  function setsFrom(products) {
    var sets = [];
    (products || []).forEach(function (product) {
      var options = product.options || [];
      if (options.length < 2) return;
      var keys = options.map(function (option) {
        return normalize(pieceName(option.name));
      });
      if (keys.some(function (key) { return !key; })) return;
      sets.push({
        handle: product.handle,
        name: String(product.title || '').replace(/^conjunto\s+/i, '').trim(),
        pieces: options.map(function (option) { return pieceName(option.name); }),
        keys: keys,
      });
    });
    return sets;
  }

  function matchSet(set, lines) {
    var matched = set.keys.map(function () { return null; });
    lines.forEach(function (line) {
      var index = set.keys.indexOf(normalize(line.product_title));
      if (index !== -1 && !matched[index]) matched[index] = line;
    });
    return matched;
  }

  // Primero un look al que le falta una pieza; si no, piezas sueltas que ya forman el look completo
  // (se ofrece cambiarlas por el conjunto). Los conjuntos que ya están en el carrito no se vuelven a ofrecer.
  function pickSet(sets, cart) {
    var lines = cartLines(cart);
    var bundlesInCart = {};
    lines.forEach(function (line) { bundlesInCart[line.handle] = true; });
    var partial = null;
    var loose = null;
    sets.forEach(function (set) {
      if (bundlesInCart[set.handle]) return;
      var matched = matchSet(set, lines);
      if (!matched.some(Boolean)) return;
      if (matched.some(function (line) { return !line; })) {
        if (!partial) partial = { set: set, matched: matched, inCart: false };
      } else if (!loose) {
        loose = { set: set, matched: matched, inCart: false };
      }
    });
    return partial || loose;
  }

  // Precio de una pieza suelta (por su nombre exacto), para calcular el ahorro sobre el precio separado.
  function piecePrice(name) {
    var url = shopRoot() + 'search/suggest.json?q=' + encodeURIComponent(name) + '&resources[type]=product&resources[limit]=6';
    return fetchJson(url)
      .then(function (data) {
        var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
        var key = normalize(name);
        var hit = products.filter(function (product) { return normalize(product.title) === key; })[0];
        return hit ? Math.round(Number(hit.price) * 100) : null;
      })
      .catch(function () { return null; });
  }

  function separatePrice(pick) {
    return Promise.all(pick.set.pieces.map(function (name, index) {
      var line = pick.matched[index];
      if (line) return Number(line.original_price) || null;
      return piecePrice(name);
    })).then(function (prices) {
      if (prices.some(function (price) { return !price; })) return 0;
      return prices.reduce(function (sum, price) { return sum + price; }, 0);
    });
  }

  function lineValue(line, values) {
    var options = (line && line.options_with_values) || [];
    var sized = options.filter(function (option) { return SIZE_NAME.test(option.name || ''); })[0];
    var candidates = sized ? [sized].concat(options) : options;
    for (var i = 0; i < candidates.length; i++) {
      if (values.indexOf(candidates[i].value) !== -1) return candidates[i].value;
    }
    return values.length === 1 ? values[0] : null;
  }

  function matchesSelection(variant, selection, skip) {
    return selection.every(function (value, index) {
      return index === skip || value == null || variant.options[index] === value;
    });
  }

  function valueAvailable(product, selection, index, value) {
    return (product.variants || []).some(function (variant) {
      return variant.available && variant.options[index] === value && matchesSelection(variant, selection, index);
    });
  }

  function variantFor(product, selection) {
    return (product.variants || []).filter(function (variant) {
      return variant.available && matchesSelection(variant, selection, -1);
    })[0] || null;
  }

  function pieceSentence(titles, labels) {
    if (titles.length < 2) return titles[0] || '';
    if (titles.length === 2) {
      return fill(labels.textTwo, { first: titles[0], second: titles[1] });
    }
    var pieces = titles.slice(0, -1).join(', ') + ' y ' + titles[titles.length - 1];
    return fill(labels.textMany, { pieces: pieces });
  }

  ready(function () {
    var root = document.querySelector('[data-rd-upsell]');
    if (!root || root.dataset.rdReady === 'true') return;
    root.dataset.rdReady = 'true';

    var collectionUrl = root.dataset.collectionUrl || '';
    var labels = {
      eyebrow: root.dataset.labelEyebrow || '',
      button: root.dataset.labelButton || '',
      confirm: root.dataset.labelConfirm || '',
      added: root.dataset.labelAdded || '',
      error: root.dataset.labelError || '',
      choosePiece: root.dataset.labelChoosePiece || '',
      soldOut: root.dataset.labelSoldOut || '',
      title: root.dataset.labelTitle || '',
      textTwo: root.dataset.labelTextTwo || '',
      textMany: root.dataset.labelTextMany || '',
      savings: root.dataset.labelSavings || '',
      price: root.dataset.labelPrice || '',
      save: root.dataset.labelSave || '',
    };

    var requestId = 0;
    var setsRequest = null;
    var offer = null;

    function loadSets() {
      if (!collectionUrl) return Promise.resolve([]);
      if (!setsRequest) {
        setsRequest = fetchJson(collectionUrl + '/products.json?limit=250')
          .then(function (data) { return setsFrom(data.products); })
          .catch(function () {
            setsRequest = null;
            return [];
          });
      }
      return setsRequest;
    }

    function hide() {
      offer = null;
      root.hidden = true;
      root.innerHTML = '';
    }

    function pickerHtml(index) {
      var product = offer.product;
      var values = product.options[index].values || [];
      return (
        '<div class="rd-upsell__pick" data-rd-upsell-pick="' + index + '">' +
          '<p class="rd-upsell__prompt">' + escapeHtml(fill(labels.choosePiece, { piece: offer.set.pieces[index] })) + '</p>' +
          '<div class="rd-upsell__sizes">' +
            values.map(function (value) {
              var selected = offer.selection[index] === value;
              var enabled = valueAvailable(product, offer.selection, index, value);
              return (
                '<button type="button" class="rd-upsell__size' + (selected ? ' is-selected' : '') + '" data-rd-upsell-size data-option="' + index + '" data-size="' + escapeHtml(value) + '"' +
                (selected ? ' aria-pressed="true"' : ' aria-pressed="false"') +
                (enabled ? '' : ' disabled') + '>' + escapeHtml(value) + '</button>'
              );
            }).join('') +
          '</div>' +
        '</div>'
      );
    }

    function renderPickers() {
      var box = root.querySelector('[data-rd-upsell-pickers]');
      if (!box || !offer) return;
      box.innerHTML = offer.open.map(pickerHtml).join('');
      var confirm = root.querySelector('[data-rd-upsell-confirm]');
      if (confirm) confirm.disabled = !variantFor(offer.product, offer.selection) || offer.selection.some(function (value) { return value == null; });
    }

    function render(next) {
      offer = next;
      var product = next.product;
      var set = next.set;
      var titles = next.matched.length
        ? next.matched.map(function (line, index) { return line ? line.product_title : set.pieces[index]; })
        : set.pieces.slice();
      var order = next.matched.length
        ? titles.filter(function (_, index) { return next.matched[index]; }).concat(titles.filter(function (_, index) { return !next.matched[index]; }))
        : titles;

      var reference = variantFor(product, next.selection) || variantFor(product, []) || (product.variants || [])[0] || {};
      var price = Number(reference.price) || 0;
      var compare = Number(reference.compare_at_price) || 0;
      var separateSavings = next.separate > price ? next.separate - price : 0;
      var savings = Math.max(compare > price ? compare - price : 0, separateSavings);
      var replaced = next.matched.reduce(function (sum, line) {
        return sum + (line ? Number(line.final_price) || 0 : 0);
      }, 0);
      var extra = Math.max(price - replaced, 0);

      var text = pieceSentence(order, labels);
      if (savings > 0) text += fill(labels.savings, { amount: formatMoney(savings) });
      var note = extra > 0 ? fill(labels.price, { amount: formatMoney(extra) }) : '';
      if (savings > 0) note += (note ? ' · ' : '') + fill(labels.save, { amount: formatMoney(savings) });

      var complete = next.complete;
      var canAdd = !complete && next.available;
      var direct = canAdd && next.open.length === 0;
      var image = product.featured_image || '';
      var media = image
        ? '<a class="rd-upsell__media" href="' + escapeHtml(product.url || '') + '"><img class="rd-upsell__image" alt="' + escapeHtml(set.name) + '" src="' + escapeHtml(image) + '"></a>'
        : '';

      root.classList.toggle('rd-upsell--no-media', !image);
      root.hidden = false;
      root.innerHTML =
        media +
        '<div class="rd-upsell__content">' +
          (labels.eyebrow ? '<p class="rd-eyebrow">' + escapeHtml(labels.eyebrow) + '</p>' : '') +
          '<p class="rd-upsell__title">' + escapeHtml(fill(labels.title, { name: set.name })) + '</p>' +
          '<div class="rd-upsell__text"><p>' + escapeHtml(text) + '</p></div>' +
          '<div class="rd-upsell__actions">' +
            (canAdd
              ? '<button type="button" class="rd-btn rd-btn--primary rd-btn--sm rd-upsell__add" data-rd-upsell-add' + (direct ? ' data-direct="true"' : '') + '>' + escapeHtml(labels.button) + '</button>'
              : '') +
            (canAdd && !direct
              ? '<div class="rd-upsell__pickers" data-rd-upsell-pickers hidden></div>' +
                (next.open.length > 1
                  ? '<button type="button" class="rd-btn rd-btn--primary rd-btn--sm rd-upsell__add" data-rd-upsell-confirm hidden disabled>' + escapeHtml(labels.confirm) + '</button>'
                  : '')
              : '') +
            '<p class="rd-upsell__status' + (complete ? '' : ' is-error') + '" data-rd-upsell-status' + (canAdd ? ' hidden' : '') + '>' +
              escapeHtml(complete ? labels.added : labels.soldOut) +
            '</p>' +
            (complete || !note ? '' : '<span class="rd-upsell__note">' + escapeHtml(note) + '</span>') +
          '</div>' +
        '</div>';
    }

    function showError() {
      var status = root.querySelector('[data-rd-upsell-status]');
      if (!status) return;
      status.textContent = labels.error;
      status.classList.add('is-error');
      status.hidden = false;
    }

    function swapToBundle(button) {
      if (!offer || root.dataset.busy === 'true') return;
      var variant = variantFor(offer.product, offer.selection);
      if (!variant) {
        showError();
        return;
      }
      var pieceVariants = offer.matched.filter(Boolean).map(function (line) { return line.variant_id; });
      var bundleHandle = offer.set.handle;
      root.dataset.busy = 'true';
      if (button) button.disabled = true;
      postJson((window.routes && window.routes.cart_add_url) || shopRoot() + 'cart/add.js', { items: [{ id: variant.id, quantity: 1 }] })
        .then(function () {
          // Line keys change once the bundle is added, so the pieces are looked up again.
          return fetchJson(cartUrl() + '.js');
        })
        .then(function (cart) {
          return pieceVariants.reduce(function (chain, variantId) {
            return chain.then(function () {
              var line = cartLines(cart).filter(function (item) {
                return item.variant_id === variantId && item.handle !== bundleHandle;
              })[0];
              if (!line) return null;
              return postJson((window.routes && window.routes.cart_change_url) || shopRoot() + 'cart/change.js', {
                id: line.key,
                quantity: Math.max(Number(line.quantity) - 1, 0),
              }).then(function (updated) {
                cart = updated;
              });
            });
          }, Promise.resolve());
        })
        .then(function () {
          var cartItems = document.querySelector('cart-items');
          if (cartItems && typeof cartItems.onCartUpdate === 'function') return cartItems.onCartUpdate();
        })
        .then(function () {
          return fetchJson(cartUrl() + '.js');
        })
        .then(function (cart) {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: cart });
          }
          root.dataset.busy = 'false';
          return refresh();
        })
        .catch(function () {
          root.dataset.busy = 'false';
          if (button) button.disabled = false;
          showError();
        });
    }

    root.addEventListener('click', function (event) {
      if (!offer) return;
      var sizeButton = event.target.closest('[data-rd-upsell-size]');
      if (sizeButton) {
        var index = Number(sizeButton.getAttribute('data-option'));
        offer.selection[index] = sizeButton.getAttribute('data-size');
        if (offer.open.length === 1) {
          swapToBundle(sizeButton);
          return;
        }
        renderPickers();
        return;
      }
      if (event.target.closest('[data-rd-upsell-confirm]')) {
        swapToBundle(event.target.closest('[data-rd-upsell-confirm]'));
        return;
      }
      var addButton = event.target.closest('[data-rd-upsell-add]');
      if (!addButton) return;
      if (addButton.getAttribute('data-direct') === 'true') {
        swapToBundle(addButton);
        return;
      }
      var box = root.querySelector('[data-rd-upsell-pickers]');
      var confirm = root.querySelector('[data-rd-upsell-confirm]');
      if (box) box.hidden = false;
      if (confirm) confirm.hidden = false;
      addButton.hidden = true;
      renderPickers();
    });

    function buildOffer(pick, product, cart) {
      var options = product.options || [];
      var selection = options.map(function (option, index) {
        var line = pick.matched[index];
        if (line) return lineValue(line, option.values || []);
        return (option.values || []).length === 1 ? option.values[0] : null;
      });
      var fixedMissing = pick.matched.some(function (line, index) {
        return line && selection[index] == null;
      });
      var open = [];
      selection.forEach(function (value, index) {
        if (value == null && !pick.matched[index]) open.push(index);
      });
      var available = !fixedMissing && (product.variants || []).some(function (variant) {
        return variant.available && matchesSelection(variant, selection, -1);
      });
      return {
        cart: cart,
        set: pick.set,
        product: product,
        matched: pick.matched,
        selection: selection,
        open: open,
        available: available,
        complete: Boolean(pick.inCart),
      };
    }

    function refresh() {
      var id = ++requestId;
      return Promise.all([loadSets(), fetchJson(cartUrl() + '.js')])
        .then(function (results) {
          if (id !== requestId) return null;
          var pick = pickSet(results[0], results[1]);
          if (!pick) {
            hide();
            return null;
          }
          return Promise.all([fetchProduct(pick.set.handle), separatePrice(pick)]).then(function (loaded) {
            if (id !== requestId) return;
            var next = buildOffer(pick, loaded[0], results[1]);
            next.separate = loaded[1];
            render(next);
          });
        })
        .catch(function () {
          if (id === requestId) hide();
        });
    }

    refresh();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        if (root.dataset.busy === 'true') return;
        refresh();
      });
    }
  });
})();
